export default {
  SET_HOLES(state, holes) {
    state.holes = holes
  },
  ADD_HOLE(state, hole) {
    state.holes.unshift(hole)
  },
  UPDATE_HOLE(state, hole) {
    const index = state.holes.findIndex((h) => h.holeId === hole.holeId)
    Object.assign(state.holes[index], hole)
  },
  REMOVE_HOLE(state, holeId) {
    const index = state.holes.findIndex((h) => h.holeId === holeId)
    state.holes.splice(index, 1)
  },
  SET_DRILLS(state, drills) {
    state.drills = drills
  },
  ADD_DRILL(state, drill) {
    state.drills.unshift(drill)
  },
  UPDATE_DRILL(state, drill) {
    const index = state.drills.findIndex((d) => d.drillRigId === drill.drillRigId)
    Object.assign(state.drills[index], drill)
  },
  REMOVE_DRILL(state, drillRigId) {
    const index = state.drills.findIndex((d) => d.drillRigId === drillRigId)
    state.drills.splice(index, 1)
  },
  SET_CONTRACTS(state, contracts) {
    state.contracts = contracts
  },
  ADD_CONTRACT(state, contract) {
    state.contracts.unshift(contract)
  },
  UPDATE_CONTRACT(state, contract) {
    const index = state.contracts.findIndex((c) => c.contractId === contract.contractId)
    Object.assign(state.contracts[index], contract)
  },
  REMOVE_CONTRACT(state, contractId) {
    const index = state.contracts.findIndex((c) => c.contractId === contractId)
    state.contracts.splice(index, 1)
  },
  SET_ZONES(state, zones) {
    state.zones = zones
  },
  SET_COMPANIES(state, companies) {
    state.companies = companies
  },
  ADD_COMPANY(state, company) {
    state.companies.unshift(company)
  },
  UPDATE_COMPANY(state, company) {
    const index = state.companies.findIndex((c) => c.companyId === company.companyId)
    Object.assign(state.companies[index], company)
  },
  REMOVE_COMPANY(state, companyId) {
    const index = state.companies.findIndex((c) => c.companyId === companyId)
    state.companies.splice(index, 1)
  },
  SET_PROJECTS(state, projects) {
    state.projects = projects
  },
  REMOVE_PROJECT(state, projectId) {
    const index = state.projects.findIndex((p) => p.projectId === projectId)
    state.projects.splice(index, 1)
  },
  SET_PROJECT_CODES(state, codes) {
    state.projectCodes = codes
  },
  SET_TASK_CATEGORIES(state, categories) {
    state.taskCategories = categories
  },
  SET_TASK_CATEGORIES_PREFERRED(state, categories) {
    state.taskCategoriesPreferred = categories
  },
  ADD_TASK_CATEGORY(state, category) {
    state.taskCategories.push(category)
  },
  UPDATE_TASK_CATEGORY(state, category) {
    const index = state.taskCategories.findIndex((c) => c.id === category.id)
    Object.assign(state.taskCategories[index], category)
  },
  REMOVE_TASK_CATEGORY(state, categoryId) {
    const index = state.taskCategories.findIndex((c) => c.id === categoryId)
    state.taskCategories.splice(index, 1)
  },
  SET_TASKS(state, tasks) {
    state.tasks = tasks
  },
  ADD_TASK(state, task) {
    const categoryIndex = state.taskCategories.findIndex((_) => _.id === task.categoryId)
    state.taskCategories[categoryIndex].tasks.push(task);
  },
  UPDATE_TASK(state, task) {
    const categoryIndex = state.taskCategories.findIndex((_) => _.id === task.categoryId)
    const taskIndex = state.taskCategories[categoryIndex].tasks.findIndex((c) => c.id === task.id)
    Object.assign(state.taskCategories[categoryIndex].tasks[taskIndex], task)
  },
  REMOVE_TASK(state, ids) {
    const categoryIndex = state.taskCategories.findIndex((_) => _.id === ids.categoryId)
    const index = state.taskCategories[categoryIndex].tasks.findIndex((c) => c.id === ids.taskId)
    state.taskCategories[categoryIndex].tasks.splice(index, 1)
  },
  SET_EMPLOYEE_TITLES(state, titles) {
    state.employeeTitles = titles
  },
  SET_STAGING_DAILY_REPORT_SELECTED_DATE(state, selectedDate) {
    state.stagingDailyReport.selectedDate = selectedDate
  },
  SET_CORE_BARRELS(state, coreBarrels) {
    state.coreBarrels = coreBarrels
  },
  SET_INSTRUMENTS(state, items) {
    state.instruments = items
  }
}
